import ShareableLinkDocumentsList from './ShareableLinkDocumentsList.component';

export default ShareableLinkDocumentsList;
